import { apiFetch } from './core'

export function fetchMyLearningAgenda() {
    return apiFetch('/learning/agenda/me')
}

export const learningAgenda = {
    fetchMine: fetchMyLearningAgenda,
}

